import { PersonalInfo } from '../types';

export const personalInfo: PersonalInfo = {
  name: "Doug Davies",
  title: "Senior Software Engineering Manager",
  email: "contact@douglasjdavies.com",
  phone: "",
  location: "Currently in Austin, TX - relocating to Irvine, CA area",
  summary: `I view software engineering as a strategic multiplier — the systems and processes we build don’t just solve problems; they shape how effectively people and organizations can operate, adapt, and grow. Well-crafted software amplifies human capability, reduces friction, and creates leverage across teams and entire businesses.

My focus is on building environments where engineering excellence is sustainable — not just through robust, maintainable systems, but by creating the conditions where engineers can consistently do their best work. This means fostering development practices that balance speed and quality, from disciplined code reviews and CI/CD automation to thoughtful architectural design and a culture of clarity, precision, and ownership.

Adept at bridging technical execution with business objectives, with hands-on expertise in software development, cloud infrastructure, and process optimization. Proven ability to lead teams across startup and enterprise environments, ensuring that what is built today accelerates what's possible tomorrow.

My approach is rooted in a simple belief — that what we build today should not only work, but accelerate what’s possible tomorrow, for the business and for the people who build it.`,
  avatar: "/headshot.jpg",
  resumeUrl: "Contact for resume",
  socialLinks: {
    linkedin: "https://linkedin.com/in/douglas-davies-535b4731",
    github: "https://github.com/Kashmir9d90",
    twitter: ""
  }
}; 
